import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getUserUrlPrefix } from '../../auth/selectors';

const mapStateToProps = state => ({
  baseUrl: `${getUserUrlPrefix(state)}/memberships`,
});

export default compose(
  connect(mapStateToProps)
);
